<template>
    <v-container fluid class="pt-0">
        <HeaderListaPlanejamentoEcomm
            titulo="Cadastro de Plano/Pacote"
            :pesquisa.sync="pesquisa"
            @exportar="exportar"
            @importar="abrirImportacao"
            hideCadastrar
        />

        <v-card class="px-5 py-5 br-15 w-100 mt-5" elevation="0">
            <v-data-table
                class="elevation-0 tabela"
                :headers="headers"
                :items="dados"
                :items-per-page="10"
                :footer-props="tableConfig"
                :header-props="{ sortIcon: 'mdi-chevron-down' }"
                :search="pesquisa"
                v-model="selecionado"
                item-key="id_pacote"
                multi-sort
                show-select
            >
                <template v-slot:[`item.ativo`]="{ item }">
                    <v-btn
                        :icon="isAtivo(item.ativo)"
                        :color="isAtivo(item.ativo) ? 'success' : 'error'"
                        @click="toggleAtivacao(item)"
                        :loading="item.carregando"
                        :disabled="item.carregando"
                        size="small"
                        class="mx-1"
                    >
                        <v-icon>{{ isAtivo(item.ativo) ? 'mdi-power' : 'mdi-power-off' }}</v-icon>
                    </v-btn>
                </template>
            </v-data-table>
            <div class="table-footer-prepend">
                <v-btn
                    color="success"
                    class="new-button mt-3"
                    v-if="selecionado.length > 0"
                    :loading="carregandoAcaoLote"
                    :disabled="carregandoAcaoLote"
                    dark
                    @click="ativarDesativarSelecionados(true)"
                >
                    Ativar selecionados
                </v-btn>
                <v-btn
                    color="error"
                    class="new-button mt-3 ml-3"
                    v-if="selecionado.length > 0"
                    :loading="carregandoAcaoLote"
                    :disabled="carregandoAcaoLote"
                    dark
                    @click="ativarDesativarSelecionados(false)"
                >
                    Desativar selecionados
                </v-btn>
            </div>

        </v-card>
        
        <!-- Componente de importação -->
        <Importacao
            v-model="dialogoImportacao"
            @filtrar="filtrar"
        />
        
        <v-overlay :value="carregando" :z-index="300">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </v-container>
</template>

<script>
import HeaderListaPlanejamentoEcomm from '@/views/planejamento_ecommerce/cadastro_plano_pacote/_components/headerListaPlanejamentoEcomm.vue'
import Importacao from './Importacao.vue'

export default {
    name: 'plano_pacote',
    components: {
        HeaderListaPlanejamentoEcomm,
        Importacao,
    },

    data() {
        return {
            carregando: false,
            carregandoAcaoLote: false,
            pesquisa: '',
            dialogoImportacao: false,
            dados: [],
            selecionado: [],
            tableConfig: {
                itemsPerPageOptions: [5, 10, 20, 50, 100, -1],
                itemsPerPageText: 'Linhas por páginas',
                ofText: 'de',
                pageText: '{0}-{1} de {2}',
            },
            headers: [
                {
                    text: 'Ativo',
                    value: 'ativo',
                    class: 'th-separador min-width-100',
                    align: 'center',
                    sortable: false,
                },
                {
                    text: 'ID',
                    value: 'id_pacote',
                    class: 'th-separador min-width-100',
                    align: 'center',
                },
                {
                    text: 'Ano',
                    value: 'ano',
                    class: 'th-separador min-width-100',
                    align: 'center',
                },

                {
                    text: 'ID Plano Pacote',
                    value: 'id_plano_pacote',
                    class: 'th-separador min-width-100',
                    align: 'center',
                },
                {
                    text: 'Plano',
                    value: 'plano',
                    class: 'th-separador min-width-100',
                    align: 'center',
                },
                {
                    text: 'Pacote',
                    value: 'pacote',
                    class: 'th-separador min-width-100',
                    align: 'center',
                },
                {
                    text: 'Ativação',
                    value: 'ativacao',
                    class: 'th-separador min-width-100',
                    align: 'center',
                },
                {
                    text: 'Categoria',
                    value: 'categoria',
                    class: 'th-separador min-width-100',
                    align: 'center',
                },
                {
                    text: 'Período',
                    value: 'periodo',
                    class: 'th-separador min-width-100',
                    align: 'center',
                },
                {
                    text: 'Device',
                    value: 'device',
                    class: 'th-separador min-width-100',
                    align: 'center',
                },
                {
                    text: 'Espaço Acordo',
                    value: 'espaco_acordo',
                    class: 'th-separador min-width-100',
                    align: 'center',
                },
                {
                    text: 'Quantidade',
                    value: 'quantidade',
                    class: 'th-separador min-width-100',
                    align: 'center',
                },
            ],
        }
    },

    created() {
        this.filtrar()
    },
    methods: {
        async exportar() {
            try {
                const response = await this.$http().post(
                    '/planejamentoEcommerce/pacotes/exportar',
                    {}
                )

                if (response.status == 200) {
                    window.location = this.$http('baseURL') + response.data.url
                    this.$dialog.notify.success('Plano/Pacote exportado com sucesso!')
                } else {
                    this.$dialog.notify.error(
                        response.data.mensagem || 'Erro ao exportar Plano/Pacote!'
                    )
                }
            } catch (error) {
                this.$dialog.notify.error('Erro de conexão ao exportar Plano/Pacote!')
                console.error('Erro na exportação:', error)
            }
        },
        
        abrirImportacao() {
            this.dialogoImportacao = true
        },
        async filtrar() {
            try {
                this.carregando = true
                const response = await this.$http().post(
                    '/planejamentoEcommerce/pacotes/lista',
                    {}
                )

                this.dados = (response.data?.data || []).map(item => ({
                    ...item,
                    carregando: false,
                    ativo: this.normalizarAtivo(item.ativo),
                }))
            } catch (error) {
                console.error('Erro ao carregar dados:', error)
                this.$dialog.notify.error('Erro ao carregar lista de Plano/Pacote!')
                this.dados = []
            } finally {
                this.carregando = false
            }
        },
        async toggleAtivacao(item) {
            this.$set(item, 'carregando', true)

            try {
                const data = {
                    id_pacote: item.id_pacote,
                }

                const response = await this.$http().post(
                    '/planejamentoEcommerce/pacotes/ativarDesativar',
                    data
                )

                if (response.status === 200 && response.data.sucesso === 1) {
                    this.$set(item, 'ativo', this.normalizarAtivo(response.data.ativo))

                    const mensagem = this.normalizarAtivo(response.data.ativo)
                        ? 'Plano/Pacote ativado com sucesso!'
                        : 'Plano/Pacote desativado com sucesso!'
                    this.$dialog.notify.success(mensagem)
                } else if (response.status === 200 && response.data.sucesso === 0) {
                    this.$dialog.notify.warning(
                        response.data.msg || 'Não foi possível desativar. Verifique se existem planejamentos ou acordos ativos.'
                    )
                } else {
                    this.$dialog.notify.error('Erro ao processar a ativação')
                }
            } catch (error) {
                console.error('Erro ao alternar ativação:', error)
                const mensagemErro =
                    error.response?.data?.msg ||
                    error.response?.data?.mensagem ||
                    'Erro ao processar a ativação'
                this.$dialog.notify.error(mensagemErro)
            } finally {
                this.$set(item, 'carregando', false)
            }
        },
        async ativarDesativarSelecionados(ativo) {
            if (!this.selecionado.length) {
                this.$dialog.notify.warning('Selecione ao menos um registro.')
                return
            }

            this.carregandoAcaoLote = true

            try {
                const ids = this.selecionado
                    .map((item) => item.id_pacote)
                    .filter((id) => id !== null && id !== undefined)

                const response = await this.$http().post(
                    '/planejamentoEcommerce/pacotes/ativarDesativarVarios',
                    {
                        ids,
                        ativo,
                    }
                )

                if (response.status === 200) {
                    const { processados, total, msg, erros } = response.data || {}
                    const mensagemPadrao =
                        processados === total
                            ? `Registros ${ativo ? 'ativados' : 'desativados'} com sucesso!`
                            : `${processados || 0} de ${total || ids.length} registro(s) processado(s) com sucesso.`

                    if (processados === total) {
                        this.$dialog.notify.success(msg || mensagemPadrao)
                    } else {
                        this.$dialog.notify.warning(msg || mensagemPadrao)
                    }

                    if (Array.isArray(erros) && erros.length) {
                        const primeiraMensagemErro = erros[0]?.msg
                        if (primeiraMensagemErro) {
                            this.$dialog.notify.warning(primeiraMensagemErro)
                        }
                    }

                    this.selecionado = []
                    await this.filtrar()
                } else {
                    this.$dialog.notify.error('Erro ao processar ativação em lote.')
                }
            } catch (error) {
                console.error('Erro ao ativar/desativar em lote:', error)
                const mensagemErro =
                    error.response?.data?.msg ||
                    error.response?.data?.mensagem ||
                    'Erro ao processar ativação em lote.'
                this.$dialog.notify.error(mensagemErro)
            } finally {
                this.carregandoAcaoLote = false
            }
        },
        normalizarAtivo(valor) {
            if (typeof valor === 'boolean') return valor
            if (typeof valor === 'number') return valor === 1
            if (typeof valor === 'string') {
                const normalizado = valor.trim().toLowerCase()
                return ['1', 'true', 'v', '[v]', 'sim', 's', 'yes', 'y', 'ativo'].includes(normalizado)
            }
            return false
        },
        isAtivo(valor) {
            return this.normalizarAtivo(valor)
        },
    },
}
</script>
